import { FC } from "react";
import { ButtonProps } from "./Button.constants";
import { Button as ButtonComponent } from "reactstrap";

const Button: FC<ButtonProps> = ({
  type = "submit",
  variant,
  text,
  iconSrc = "",
  loading,
  disabled,
  onClick,
}) => {
  return (
    <ButtonComponent
      onClick={onClick}
      disabled={loading ? loading : disabled}
      className={`w-100 btn btn-${variant} waves-effect waves-light`}
      type={type}
      color=""
    >
      {text}{" "}
      <i
        className={`bx bx-${
          loading ? "loader bx-spin" : iconSrc
        } font-size-16 align-middle me-2`}
      ></i>
    </ButtonComponent>
  );
};

export default Button;
